import type { ReactNode } from 'react';
import './badge.css';

type Tone = 'neutral' | 'brand' | 'positive' | 'negative' | 'warning' | 'teal';

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

/** Delta chip of a KPI card: green when improving, red when degrading. */
export function DeltaChip({ ratio }: { ratio: number | null }) {
  if (ratio === null) return null;
  const up = ratio >= 0;
  return (
    <span className={`badge badge--${up ? 'positive' : 'negative'}`}>
      {Math.abs(ratio * 100).toFixed(1)}% {up ? '↗' : '↘'}
    </span>
  );
}
